import unescapedText from 'I18n/utils/unescapedText';
import { getActionText } from 'copilot-toolkit/actions/getActionText';
import { parseInAppCopilotAction } from 'copilot-toolkit/actions/parseInAppCopilotAction';
import { OBJECT_ENGAGEMENTS_SUMMARY, OBJECT_SUMMARY } from 'copilot-toolkit/constants/CopilotInAppActionTypes';
const getDefaultMessage = () => {
  return unescapedText('aiAddonCopilotPreview.components.copilotV2.defaultMessage');
};

/**
 * Maps data from V1 format to V2 format for Copilot Preview
 * Handles specific intents: object_summary and object_engagement_summary
 * @param copilotAction The V1 format copilot action
 * @returns Mapped data with label and object information for V2 API
 */
export const getMapV1DataToV2 = copilotAction => {
  const messageAction = parseInAppCopilotAction(copilotAction);
  switch (copilotAction.intent) {
    case OBJECT_SUMMARY:
      return {
        message: copilotAction.label || messageAction && getActionText(messageAction) || getDefaultMessage(),
        context: {
          crmObjectContext: {
            objectTypeId: copilotAction.objectTypeId,
            objectId: Number(copilotAction.objectId)
          }
        }
      };
    case OBJECT_ENGAGEMENTS_SUMMARY:
      return {
        message: copilotAction.text || messageAction && getActionText(messageAction) || getDefaultMessage(),
        context: {
          crmObjectContext: {
            objectTypeId: copilotAction.objectType,
            objectId: Number(copilotAction.objectId)
          }
        }
      };
    default:
      return {
        message: getDefaultMessage(),
        context: {
          crmObjectContext: undefined
        }
      };
  }
};